import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licence-pending-user-list',
  templateUrl: './licence-pending-user-list.component.html',
  styleUrls: ['./licence-pending-user-list.component.css']
})
export class LicencePendingUserListComponent implements OnInit {
  title="PSA Licence Pending From User";
  toDay ;
  constructor() {    
    this.toDay = new Date();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/rpt-form/report-list/licence-pending-user-list/licence-pending-user-list.component.ts